<script setup lang="ts">
import { PRODUCT_PRICING_INJECTION_KEY } from "../../../constants/commerce";
import type { PricingState } from "../../../types";
import { BasketAddToBasket } from "#components";
import { injectRequired } from "#imports";

defineProps<{
  size?: "sm" | "md" | "lg";
  variant?: string;
  look?: string;
  label?: string | null;
  disabled?: boolean;
}>();

const state: PricingState = injectRequired( PRODUCT_PRICING_INJECTION_KEY );

// Allow the selected price and quantity to be reactive
const { selectedPrice, quantity } = toRefs( state );
</script>

<template>
  <BasketAddToBasket
    :product-id="state.productId"
    :price="selectedPrice"
    :quantity="quantity"
    :size="size"
    :variant="variant"
    :look="look"
    :label="label"
    :disabled="disabled" />
</template>

<style scoped lang="scss">

</style>
